import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { StatusDistribution, SourceDistribution, LeadsOverTime } from '../../types/reports.types';

interface ChartsSectionProps {
  statusDistribution: StatusDistribution[];
  sourceDistribution: SourceDistribution[];
  leadsOverTime: LeadsOverTime[];
}

const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'];

export const ChartsSection: React.FC<ChartsSectionProps> = ({
  statusDistribution,
  sourceDistribution,
  leadsOverTime,
}) => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }, gap: 3 }}>
      <Box>
        <Paper sx={{ p: 3 }}>
          <Typography variant='h6' gutterBottom>
            Lead Status Distribution
          </Typography>
          <ResponsiveContainer width='100%' height={300}>
            <PieChart>
              <Pie
                data={statusDistribution}
                dataKey='count'
                nameKey='status'
                cx='50%'
                cy='50%'
                outerRadius={100}
                label={(entry: any) => `${entry.status}: ${entry.count}`}
              >
                {statusDistribution.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </Paper>
      </Box>

      <Box>
        <Paper sx={{ p: 3 }}>
          <Typography variant='h6' gutterBottom>
            Leads by Source
          </Typography>
          <ResponsiveContainer width='100%' height={300}>
            <BarChart data={sourceDistribution}>
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis dataKey='source' />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey='count' fill='#3b82f6' />
            </BarChart>
          </ResponsiveContainer>
        </Paper>
      </Box>

      <Box sx={{ gridColumn: '1 / -1' }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant='h6' gutterBottom>
            Leads Over Time (Last 30 Days)
          </Typography>
          <ResponsiveContainer width='100%' height={300}>
            <LineChart data={leadsOverTime}>
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis dataKey='date' />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type='monotone' dataKey='count' stroke='#10b981' strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </Paper>
      </Box>
    </Box>
  );
};